import { Outlet } from 'react-router-dom';
import { PackagesWizardProvider } from './PackagesWizardContext';

export default function PackagesLayout() {
  return (
    <PackagesWizardProvider>
      <Outlet />
    </PackagesWizardProvider>
  );
}
